import { ColumnType } from 'antd/es/table';
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { tasksApis } from '../../api/NewTasks';


const ApprovalActionDelaysReport = () => {
    const [userIdFilterData, setUserIdFilterData] = useState([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { id: projectId, projectName } = location.state || {};

    const columns: ColumnType<any>[] = [
        {
            title: "User Name",
            dataIndex: "userName",
            key: "userName",
            width: 80,
            fixed: "left",
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Task Title",
            dataIndex: "taskName",
            key: "taskName",
            width: 100,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`Task-${record?.uid}`}
                            onClick={() => {
                                navigate(`/pms/project/task-detail/${record.taskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Triggered On",
            dataIndex: "triggeredOn",
            key: "triggeredOn",
            width: 50,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Delay (Days)",
            dataIndex: "delayedDays",
            key: "delayedDays",
            width: 50,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Days`)
        },
    ]
    const fetchUserDropdown = async () => {
        try {
            const response = await tasksApis.getOwnersFilterData(
                projectId?.toString()
            );
            const { data, status } = response || {};
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };

                });
                setUserIdFilterData(options);
            }
        } catch (error) {
            console.error("eroor")
        }
    }


    useEffect(() => {
        fetchUserDropdown();
        dispatch(
            updateMenuData([
                {
                    text: "Approvals Action Delays Report",
                    link: "pms/approvals-action-delays-report",
                },
            ])
        );
    }, []);

    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Approvals & Action Delays Report'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Custom Date Range",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: userIdFilterData,
                        },
                    ]
                }}
            />
        </>
    );
}

export default ApprovalActionDelaysReport;